import { render, staticRenderFns } from "./registerModelTwo.vue?vue&type=template&id=9287543c"
import script from "./registerModelTwo.vue?vue&type=script&lang=js"
export * from "./registerModelTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports